import React from "react";
import { Link, type LinkProps } from "react-router-dom";
import { buttonClassName, type ButtonSize, type ButtonVariant } from "./buttonStyles";

interface ButtonLinkProps extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
}

/**
 * A link that looks like a Button (#147). Wrapping a <Button> in a <Link>
 * makes two nested controls: invalid HTML, two tab stops for one action, and
 * announced twice. This is one control, laid out as Button lays out its
 * content. An icon with no label needs an aria-label, as a Button does.
 */
export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ variant = "primary", size = "md", icon, iconRight, children, className = "", ...rest }, ref) => {
    const iconOnly = !children && Boolean(icon || iconRight);
    return (
      <Link ref={ref} className={buttonClassName({ variant, size, iconOnly, className })} {...rest}>
        {icon && <span className="shrink-0">{icon}</span>}
        {children && <span>{children}</span>}
        {iconRight && <span className="shrink-0">{iconRight}</span>}
      </Link>
    );
  }
);

ButtonLink.displayName = "ButtonLink";
